/**
 * Function to show notification globally.
 * @param {String} message Message to show in the notification.
 * @param {Boolean} isError Boolean to control if the message is an error.
 */
export function showNotification(message, isError = true) {
    return {
        type: 'SHOW_NOTIFICATION',
        payload: {
            message,
            isError,
        },
    };
}

/**
 * Function to clear notification.
 */
export function clearNotification() {
    return {
        type: 'CLEAR_NOTIFICATION',
    };
}
